const nodes = [
  { id: "pages",    label: "Pages",            x: 120,  y: 190, color: "#6366f1", shape: "rect" },
  { id: "workers",  label: "Workers",           x: 260,  y: 190, color: "#0ea5e9", shape: "diamond" },
  { id: "do",       label: "Durable Objects",   x: 420,  y: 190, color: "#F48120", shape: "diamond" },
  { id: "d1",       label: "D1",                x: 340,  y: 60,  color: "#F48120", shape: "cylinder" },
  { id: "workflow", label: "Workflows",          x: 580,  y: 190, color: "#10b981", shape: "hexagon" },
  { id: "gateway",  label: "AI Gateway",         x: 740,  y: 190, color: "#ec4899", shape: "brain" },
  { id: "workersai",label: "Workers AI",         x: 740,  y: 60,  color: "#8b5cf6", shape: "starburst" },
  { id: "search",   label: "AI Search",          x: 900,  y: 190, color: "#06b6d4", shape: "search" },
  { id: "hitl",     label: "Human-in-the-loop",  x: 580,  y: 340, color: "#f59e0b", shape: "person" },
  { id: "sandbox",  label: "Sandbox",            x: 740,  y: 340, color: "#64748b", shape: "box" },
  { id: "r2",       label: "R2",                 x: 900,  y: 340, color: "#F48120", shape: "cylinder" },
];

const edges = [
  { from: "pages",    to: "workers",   label: "Upgrade",            dashed: false },
  { from: "workers",  to: "do",        label: "",                   dashed: false },
  { from: "do",       to: "d1",        label: "SQL query",          dashed: false },
  { from: "do",       to: "workflow",  label: "ReAct Orchestrator", dashed: false },
  { from: "workflow", to: "gateway",   label: "LLM reasoning",      dashed: false },
  { from: "gateway",  to: "workersai", label: "",                   dashed: false },
  { from: "gateway",  to: "search",    label: "",                   dashed: false },
  { from: "workflow", to: "hitl",      label: "Approval signal",    dashed: true  },
  { from: "workflow", to: "sandbox",   label: "Tool execution",     dashed: false },
  { from: "sandbox",  to: "r2",        label: "Screenshot",         dashed: false },
];

function getCenter(id: string): [number, number] {
  const n = nodes.find((n) => n.id === id);
  return n ? [n.x, n.y] : [0, 0];
}

function NodeShape({ node }: { node: typeof nodes[0] }) {
  const { x, y, color, label, shape } = node;
  const isHighlighted = ["do", "workflow", "gateway"].includes(node.id);

  const baseStyle = {
    filter: isHighlighted ? `drop-shadow(0 0 6px ${color}66)` : undefined,
  };

  if (shape === "diamond") {
    return (
      <g style={baseStyle}>
        <polygon
          points={`${x},${y - 26} ${x + 26},${y} ${x},${y + 26} ${x - 26},${y}`}
          fill={color}
          stroke="white"
          strokeWidth="2"
        />
        <text x={x} y={y + 42} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  if (shape === "cylinder") {
    return (
      <g style={baseStyle}>
        <ellipse cx={x} cy={y - 14} rx={20} ry={6} fill={color} stroke="white" strokeWidth="1.5" />
        <rect x={x - 20} y={y - 14} width={40} height={28} fill={color} />
        <ellipse cx={x} cy={y + 14} rx={20} ry={6} fill={color} stroke="white" strokeWidth="1.5" />
        <text x={x} y={y + 32} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  if (shape === "hexagon") {
    const r = 26;
    const pts = Array.from({ length: 6 }, (_, i) => {
      const a = (Math.PI / 180) * (60 * i - 30);
      return `${x + r * Math.cos(a)},${y + r * Math.sin(a)}`;
    }).join(" ");
    return (
      <g style={baseStyle}>
        <polygon points={pts} fill={color} stroke="white" strokeWidth="2" />
        <text x={x} y={y + 42} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  if (shape === "starburst") {
    return (
      <g style={baseStyle}>
        <circle cx={x} cy={y} r={22} fill={color} stroke="white" strokeWidth="2" />
        <circle cx={x} cy={y} r={14} fill="white" fillOpacity="0.25" />
        <text x={x} y={y + 38} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  if (shape === "rect") {
    return (
      <g style={baseStyle}>
        <rect x={x - 28} y={y - 20} width={56} height={40} rx={8} fill={color} stroke="white" strokeWidth="2" />
        <text x={x} y={y + 36} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  if (shape === "box") {
    return (
      <g style={baseStyle}>
        <rect x={x - 22} y={y - 22} width={44} height={44} rx={6} fill={color} stroke="white" strokeWidth="2" />
        <text x={x} y={y + 38} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  if (shape === "person") {
    return (
      <g style={baseStyle}>
        <circle cx={x} cy={y - 14} r={10} fill={color} stroke="white" strokeWidth="1.5" />
        <path d={`M${x - 16},${y + 18} Q${x},${y + 2} ${x + 16},${y + 18}`} fill={color} stroke="white" strokeWidth="1.5" />
        <text x={x} y={y + 38} textAnchor="middle" fontSize="11" fill="#374151" fontWeight="500">
          {label}
        </text>
      </g>
    );
  }

  // search
  return (
    <g style={baseStyle}>
      <circle cx={x - 4} cy={y - 4} r={16} fill="none" stroke={color} strokeWidth="3" />
      <line x1={x + 8} y1={y + 8} x2={x + 20} y2={y + 20} stroke={color} strokeWidth="3" strokeLinecap="round" />
      <text x={x} y={y + 38} textAnchor="middle" fontSize="11" fill="#94a3b8" fontWeight="500">
        {label}
      </text>
    </g>
  );
}

export default function ArchitectureDiagram() {
  return (
    <div className="bg-dark-surface rounded-xl border border-dark-border p-4 overflow-x-auto">
      <h3 className="text-[11px] font-mono font-semibold text-slate-500 uppercase tracking-widest mb-3">
        Architecture Overview
      </h3>
      <svg
        viewBox="0 0 980 420"
        className="w-full min-w-[640px]"
        style={{ fontFamily: "Inter, system-ui, sans-serif" }}
      >
        {/* User node */}
        <g>
          <circle cx={20} cy={190} r={18} fill="#6366f1" stroke="white" strokeWidth="2" />
          <circle cx={20} cy={178} r={7} fill="white" />
          <path d="M4,206 Q20,194 36,206" fill="white" />
          <text x={20} y={218} textAnchor="middle" fontSize="11" fill="#94a3b8" fontWeight="500">
            User
          </text>
        </g>

        {/* Arrow: user → pages */}
        <g>
          <line x1={38} y1={190} x2={88} y2={190} stroke="#9ca3af" strokeWidth="1.5" markerEnd="url(#arrowhead)" />
          <text x={63} y={183} textAnchor="middle" fontSize="9" fill="#475569">WebSocket</text>
        </g>

        {/* Edges */}
        <defs>
          <marker id="arrowhead" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
            <polygon points="0 0, 8 3, 0 6" fill="#9ca3af" />
          </marker>
          <marker id="arrowhead-orange" markerWidth="8" markerHeight="6" refX="8" refY="3" orient="auto">
            <polygon points="0 0, 8 3, 0 6" fill="#F48120" />
          </marker>
        </defs>

        {edges.map((edge, i) => {
          const [x1, y1] = getCenter(edge.from);
          const [x2, y2] = getCenter(edge.to);
          const mx = (x1 + x2) / 2;
          const my = (y1 + y2) / 2;
          const isOrange = edge.from === "do" || edge.to === "gateway";
          return (
            <g key={i}>
              <line
                x1={x1} y1={y1} x2={x2} y2={y2}
                stroke={isOrange ? "#F6821F" : "#334155"}
                strokeWidth="1.5"
                strokeDasharray={edge.dashed ? "5,3" : undefined}
                markerEnd={`url(#${isOrange ? "arrowhead-orange" : "arrowhead"})`}
              />
              {edge.label && (
                <text
                  x={mx}
                  y={my - 5}
                  textAnchor="middle"
                  fontSize="8"
                  fill="#475569"
                  style={{ pointerEvents: "none" }}
                >
                  {edge.label}
                </text>
              )}
            </g>
          );
        })}

        {/* Nodes */}
        {nodes.map((node) => (
          <NodeShape key={node.id} node={node} />
        ))}
      </svg>
    </div>
  );
}
